/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import {LaundryConfigHoursColumn} from '../../../../model'
import {getLaundryConfigHours} from '../../../../services'

const TableLaundryConfigHours: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination, clearSelected} = useKTable()
  const {isAllowed, currentTabItem, changeCurrentTabItem} = useLavanderia()

  const getLaundryList = async () => {
    setLoading(true)
    // let obj = {...searchValues, ...formValues}
    const response = await getLaundryConfigHours({}, pagination.currentPage)
    const dataInfo = response.data?.data || []
    if (!response.data.error) {
      setData(dataInfo)
      setPagination({
        ...pagination,
        totalResults: response.data.total,
      })
    }
    setData(dataInfo)
    setLoading(false)
  }

  const handleViewPanel = (data: LaundryConfigHoursColumn) => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: data.Id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-configuration-hours',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<LaundryConfigHoursColumn>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
      id: 'selection',
      Cell: ({...props}) => (
        <KTableSelectionCellNonMultiple
          id={props.data[props.row.index].Id}
          clickHandler={handleGetId}
        />
      ),
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Configuración' />,
      accessor: 'TipoConfiguracionNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Site' />,
      accessor: 'SiteNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Proveedor' />,
      accessor: 'ProveedorNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Valor' />,
      accessor: 'Valor',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleViewPanel(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  useEffect(() => {
    getLaundryList()
    if (currentTabItem.loadingTable) {
      clearSelected()
      getLaundryList()
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable])

  return (
    <>
      <KTCard shadow className='m-5'>
        {isAllowed('LISTAR') && (
          <>
            {loading ? <KTableLoading title='Cargando...' /> : null}
            <KTable data={data} columns={columns as any} />
          </>
        )}
      </KTCard>
    </>
  )
}

const TableLaundryConfigHoursWrapper = () => {
  return (
    <KTableProvider>
      <TableLaundryConfigHours />
    </KTableProvider>
  )
}

export {TableLaundryConfigHoursWrapper}
